import { useCallback } from 'react'
import { useHuddle } from '../../contexts/HuddleContext'
import Button from '../Common/Button'
import Icon from '../Common/Icon'
import Text from '../Common/Text'
import styles from './Huddle.module.scss'

/** Someone asked you into their huddle: join in one click, inside that click for the mic. */
const HuddleInviteToast = () => {
  const { pendingInvite, join, dismissInvite } = useHuddle()
  const handleJoin = useCallback(() => {
    if (!pendingInvite) return
    join(pendingInvite.channelId, pendingInvite.huddleId)
    dismissInvite()
  }, [dismissInvite, join, pendingInvite])

  if (!pendingInvite) return null
  const where = pendingInvite.channelLabel ? ` in ${pendingInvite.channelLabel}` : ''
  return (
    <div className={styles.invite} role="alertdialog" aria-label="Huddle invite">
      <span className={styles.inviteIcon}>
        <Icon name="headphones" size="sm" />
      </span>
      <Text variant="body" component="span" className={styles.inviteText}>
        {pendingInvite.fromName} invited you to a huddle{where}
      </Text>
      <Button secondary small onClick={dismissInvite}>
        Not now
      </Button>
      <Button small onClick={handleJoin} data-cy="huddle-invite-join">
        Join
      </Button>
    </div>
  )
}

export default HuddleInviteToast
